import './Footer.css';
import { FooterR } from '../Navbar/NavbarElements'
import { FaInstagram } from "react-icons/fa";


const Footer = () => {
  return (
     <footer className="footer">
  	 <div id='contact' className="container_footer">
  	 	<div className="row">
  	 		<div className="footer-col">
				<FooterR to="/" >
  	 				<div className='logo_footer' />
				</FooterR>
  	 		</div>
  	 		<div className="footer-col">
  	 			<h4>Snabba Länkar</h4>
  	 			<ul>
					<li>
						<p>
							<FooterR to="/catering" >
								Catering
							</FooterR>
						</p>
						<p>
							<FooterR to='/event'>
								EventLokaler
							</FooterR>
						</p>						
						<p>
							<FooterR to="/cars" >
								Bilar
							</FooterR>
						</p>
						<p>
							<FooterR to="/about" >
								Om Oss
							</FooterR>
						</p>
					</li>
  	 			</ul>
  	 		</div>
			<div className="footer-col">
  	 			<h4>Kontakta oss</h4>
  	 			<ul>
  	 				<li>
						<p>
							<a href='tel:0764130853'>
								076 413 08 53
							</a>
						</p>
						<p>	
							<a href="mailto:cateringbyprestig@gmail.com">
								cateringbyprestig@gmail.com
							</a>
						</p>
					</li>
  	 			</ul>
  	 		</div>
  	 		<div className="footer-col">
  	 			<h4>Följ oss</h4>
  	 			<div className="social-links">
					<a href='https://www.instagram.com/prestige.stockholm/'><FaInstagram /></a>
  	 			</div>
  	 		</div>
  	 	</div>
  	 </div>
  </footer>
  )
}

export default Footer